import React from "react";
import { Link } from "react-router-dom";

const Terms = () => {
    document.title = "DirtMap - Terms & Conditions";

    return (
        <div>
            <section className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 bread-crumb">
                            <Link to="/">Home</Link><span> &gt; </span>Terms & Conditions
                        </div>
                    </div>
                </div>
                <hr />
            </section>

            <section className="contentContainer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <h2>Terms & Conditions (Terms of Service)</h2>

                            <p><strong>1) Agreement to Terms</strong><br/>
                            These Terms of Service (“Terms”) govern your access to and use of dirtestimator.net (the “Site” or “Platform”) operated by dirtestimator (“dirtestimator,” “we,” “us,” “our”). By using the Platform, you agree to these Terms and our Privacy Policy. If you do not agree, do not use the Platform.</p>

                            <p><strong>2) What dirtestimator does</strong><br/>
                            dirtestimator is a listing and discovery platform that allows Site Posters to post Listings and Companies to view Listings and contact Site Posters offline. We do not handle payments, hauling, transport, disposal, or permitting.</p>

                            <p><strong>3) Free service</strong><br/>
                            The Platform is currently free. We may change features or add paid services in the future.</p>

                            <p><strong>4) Eligibility</strong><br/>
                            You must be able to form a binding contract to use the Platform.</p>

                            <p><strong>5) Accounts</strong><br/>
                            You are responsible for your account information and all activity under your account.</p>

                            <p><strong>6) Listings and user content</strong><br/>
                            You are solely responsible for the accuracy and legality of Listings you post.</p>

                            <p><strong>7) Offline contact and no involvement</strong><br/>
                            We are not a party to any agreement between users.</p>

                            <p><strong>8) No warranties</strong><br/>
                            The Platform is provided “AS IS” and “AS AVAILABLE.”</p>

                            <p><strong>9) Limitation of liability</strong><br/>
                            Our total liability will not exceed USD $100.</p>

                            <p><strong>10) Indemnification</strong><br/>
                            You agree to indemnify and hold harmless dirtestimator.</p>

                            <p><strong>11) Content license</strong><br/>
                            You grant us a license to display and distribute your content to operate the Platform.</p>

                            <p><strong>12) Moderation</strong><br/>
                            We may remove content or suspend access at any time.</p>

                            <p><strong>13) Third-party services</strong><br/>
                            The Platform may integrate third-party services like map providers.</p>

                            <p><strong>14) Acceptable use</strong><br/>
                            You agree not to misuse the Platform.</p>

                            <p><strong>15) Changes to Terms</strong><br/>
                            We may update these Terms from time to time.</p>

                            <p><strong>16) Governing law</strong><br/>
                            These Terms are governed by the laws of the State of California.</p>

                            <p><strong>17) Contact</strong><br/>
                            dirtestimator<br/>
                            1732 Brogan Dr, San Antonio TX 78232<br/>
                            Email: <a href="mailto:mail@dirtestimator.net">mail@dirtestimator.net</a></p>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Terms;
